import Header from "../Components/Header/Header";
import Parser from 'html-react-parser';
import "./faq.css";
import Footer from "../Components/Footer/Footer";

const Faq = (Props) =>{
    // console.log(Props);
    const togglePanel = (e)=>{
        if(e.target.parentNode.classList.contains('active-panel'))
            e.target.parentNode.classList.remove("active-panel")
        else
            e.target.parentNode.classList.add("active-panel")
        
    }
    return(
        <div className="common-bg">
            <div className="container">
            <Header title={Props.data.show_header_title?Props.data.title:""} type="Secondary"/>
            <div className="content-wrap bg-light">
                <div className="banner-box">
                    <div className="faq-box">
                        <div className="banner-box">
                            <div className="banner-wrap">
                                <div className="banner-content">
                                    {Parser(Props.data.content)}
                                </div>
                                <div className="banner-right-img">
                                    {Props.data.featured_image.data?<img src={Props.data.featured_image.data.attributes.url} alt="banner-img"/> :""} 
                                </div>
                            </div>    
                        </div>
                        <div className={Props.data.extra_class}>
                            <div className="faq-inner">
                            {
                            Props.data.steps.map((item, index)=>{ 
                                    return(
                                        <div key={index} onClick = {togglePanel} className="panel">
                                            <div className="question">{item.item_title}</div>
                                            <div className="answer">{item.item_description}</div>
                                        </div>
                                    )
                                })
                            }
                            </div> 
                        </div>
                    </div>    
                </div>
            </div>    
            <Footer />  
        </div>
    </div>
    );
}
export default Faq;